/**
 * Any feature flags added below need to be whitelisted in Confluence core as well, so that they are passed
 * to the frontend (there are too many to pass everything by default).
 *
 * Refer to https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-core/confluence
 * /src/java/com/atlassian/confluence/impl/spa/DefaultFrontEndDarkFeatureHelper.java
 */
export const FABRIC_PRESENCE_INTEGRATION = 'fabric.presence.integration';
export const CHANGEBOARDING_KILL_SWITCH = 'changeboarding.kill.switch';
// https://product-fabric.atlassian.net/browse/UR-1222: Use URS to fetch users/teams to mention
export { isDarkFeatureEnabled as isDarkFeatureEnabled_DO_NOT_USE } from './dark-features-meta_DO_NOT_USE';
